import * as React from "react";
import type { NotificationProvider } from "@refinedev/core";
import { Toast } from "@/components/Toast";

type ToastItem = {
  id: string;
  message: string;
  variant: "success" | "error" | "info";
};

type SetItems = React.Dispatch<React.SetStateAction<ToastItem[]>>;

let _setItems: SetItems | null = null;

export const notificationProvider: NotificationProvider = {
  open: ({ key, message, type }) => {
    const id = key ?? `toast-${Date.now()}`;
    const variant: ToastItem["variant"] =
      type === "success" ? "success" : type === "error" ? "error" : "info";
    _setItems?.((prev) => {
      if (prev.some((t) => t.id === id)) return prev;
      return [...prev, { id, message, variant }];
    });
  },
  close: (key: string) => {
    _setItems?.((prev) => prev.filter((t) => t.id !== key));
  },
};

export function ToastContainer(): React.JSX.Element | null {
  const [items, setItems] = React.useState<ToastItem[]>([]);

  React.useLayoutEffect(() => {
    _setItems = setItems;
    return () => {
      _setItems = null;
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <div
      className="fixed bottom-5 right-5 z-50 flex flex-col gap-2"
    >
      {items.map((item) => (
        <Toast
          key={item.id}
          message={item.message}
          variant={item.variant}
          onClose={() => {
            notificationProvider.close(item.id);
          }}
        />
      ))}
    </div>
  );
}
